export const scrollTo = scrollTarget => {
  const targetElement = document.querySelector(scrollTarget);
  if (targetElement) {
    targetElement.scrollIntoView({
      behavior: 'smooth'
    });
  }
};